<template>
  <div v-loading="loading" class="wh-100">
    <div v-if="!companyStatus"></div>
    <enterprise class="wh-100" v-else :companyStatus="companyStatus"></enterprise>
  </div>
</template>

<script>
import { getQueryObject } from '@/utils'
import enterprise from '@/views/clue/page/enterpriseNew'
import { searchByName } from '@/views/clue/api/newClueApi'
export default {
  name: "enterpriseDetail",
  components: {
    enterprise
  },
  data() {
    return {
      companyStatus: null,
      loading: false
    }
  },
  created() {
    this.getEnterpriseDetail()
  },
  methods: {
    getEnterpriseDetail() {
      this.loading = true
      const params = getQueryObject()
      searchByName(params).then(({ code, data, message }) => {
        if (code != 200) return
        // 处理请求结果
        const items = (data || {}).items || []
        if (items[0]) {
          this.companyStatus = { companyName: items[0].name, lockStatus: items[0].unlock, ...items[0] }
        }
      }).catch(err => { console.log('err :', err) }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wh-100 {
  width: 100%;
  height: 100%;
}
/deep/ .enterpriseBody .tabfixed.fixed {
  max-width: unset !important;
  top: 0 !important;
}
/deep/ .header .hright {
  // width: calc(100% - 70px);
}
</style>